// assets/roesch-store-locator.js
(function () {
  // Globaler Namespace
  if (!window.RoeschStoreLocator) {
    window.RoeschStoreLocator = { sections: {} };
  }

  function hasGoogleMaps() {
    return (
      typeof window.google !== "undefined" &&
      google.maps &&
      typeof google.maps.Map === "function"
    );
  }

  // Hilfsfunktion: egal ob Boolean, "true"/"false", "1", "yes", "ja" → zu Boolean
  function toBool(value) {
    if (value === true) return true;
    if (value === false || value == null) return false;
    var s = String(value).toLowerCase().trim();
    return s === "true" || s === "1" || s === "yes" || s === "ja";
  }

  function normalizeShops(rawShops) {
    return (rawShops || []).map(function (s, index) {
      var lat = parseFloat(s.lat);
      var lng = parseFloat(s.lng);

      return {
        id: s.id || String(index + 1),
        name: s.name || "",
        address: s.address || "",
        city: s.city || "",
        postalCode: s.postalCode || "",
        phone: s.phone || "",
        lat: isNaN(lat) ? null : lat,
        lng: isNaN(lng) ? null : lng
      };
    });
  }

  // --- Distanzberechnung (Haversine) ------------------------------
  function deg2rad(deg) {
    return (deg * Math.PI) / 180;
  }

  function getDistanceKm(lat1, lon1, lat2, lon2) {
    var R = 6371; // Erdradius in km
    var dLat = deg2rad(lat2 - lat1);
    var dLon = deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  // --- Kartenstil: kontrastreich, Labels an, wenig POI/Transit ----
  var mapStyles = [
    {
      featureType: "poi",
      stylers: [{ visibility: "off" }]
    },
    {
      featureType: "transit",
      stylers: [{ visibility: "off" }]
    },
    {
      featureType: "road",
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }]
    },
    {
      elementType: "geometry",
      stylers: [{ color: "#e0e0e0" }]
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#b3e5fc" }]
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#ffffff" }]
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#c0c0c0" }]
    },
    {
      elementType: "labels.text.fill",
      stylers: [{ color: "#333333" }]
    },
    {
      elementType: "labels.text.stroke",
      stylers: [
        { color: "#ffffff" },
        { weight: 2 }
      ]
    }
  ];

  // --- Custom-Icon für Rösch-Stores: Tropfen-Pin mit "R" ----------
  var roeschMarkerIconSvg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40">' +
    '  <path d="M16 2C9.924 2 5 6.924 5 13c0 7.8 7.4 15.3 10.2 18.2c0.5 0.5 1.1 0.5 1.6 0C19.6 28.3 27 20.8 27 13C27 6.924 22.076 2 16 2z"' +
    '        fill="white" stroke="black" stroke-width="2"/>' +
    '  <text x="16" y="17" text-anchor="middle"' +
    '        font-size="12" fill="black" font-family="Arial, sans-serif">R</text>' +
    "</svg>";

  var roeschMarkerIcon = null;
  function getRoeschMarkerIcon() {
    if (!roeschMarkerIcon && hasGoogleMaps()) {
      roeschMarkerIcon = {
        url:
          "data:image/svg+xml;charset=UTF-8," +
          encodeURIComponent(roeschMarkerIconSvg),
        scaledSize: new google.maps.Size(32, 40),
        anchor: new google.maps.Point(16, 32) // Spitze unten
      };
    }
    return roeschMarkerIcon;
  }

  function initSection(sectionId) {
    var dataEl = document.getElementById(
      "roesch-store-locator-data-" + sectionId
    );
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error("Roesch Store Locator JSON-Fehler:", e);
      return;
    }

    var shops = normalizeShops(data.shops || []);

    async function fetchAllMetaobjectStores(ds) {
      if (!ds || ds.kind !== "storefront_metaobjects") return [];
      if (!ds.token) {
        console.warn("Store Locator: Kein Storefront API Token gesetzt.");
        return [];
      }

      const query = `
        query($type: String!, $first: Int!, $after: String) {
          metaobjects(type: $type, first: $first, after: $after) {
            nodes {
              handle
              fields { key value }
            }
            pageInfo { hasNextPage endCursor }
          }
        }
      `;

      let after = null;
      const all = [];

      do {
        const resp = await fetch(ds.endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": ds.token
          },
          body: JSON.stringify({
            query,
            variables: { type: ds.type, first: 250, after }
          })
        });

        const json = await resp.json();
        if (json.errors) {
          console.error("Storefront API Fehler:", json.errors);
          return [];
        }

        const conn = json?.data?.metaobjects;
        if (!conn) return [];

        conn.nodes.forEach((node) => {
          const f = {};
          (node.fields || []).forEach((x) => (f[x.key] = x.value));

          all.push({
            id: node.handle,
            name: f.handlername || "",
            address: f.adresse || "",
            city: f.stadt || "",
            postalCode: f.plz || "",
            phone: f.telefon || "",
            lat: f.breitengrad,
            lng: f.langengrad
          });
        });

        after = conn.pageInfo?.hasNextPage ? conn.pageInfo.endCursor : null;
      } while (after);

      return all;
    }

    var mapEl = document.getElementById("store-map-" + sectionId);
    var placeholderEl = document.getElementById("store-map-placeholder-" + sectionId);
    var listEl = document.getElementById("store-list-" + sectionId);
    var searchInput = document.getElementById("store-search-" + sectionId);
    var radiusSelect = document.getElementById("radius-select-" + sectionId);
    var locateButton = document.getElementById("locate-button-" + sectionId);
    var form = document.getElementById("store-search-form-" + sectionId);

    if (
      !mapEl ||
      !listEl ||
      !searchInput ||
      !form ||
      !radiusSelect ||
      !locateButton
    ) {
      console.warn(
        "Roesch Store Locator: DOM-Elemente nicht gefunden für Section",
        sectionId
      );
      return;
    }

    // Zustand der Section
    var map = null;
    var markers = [];
    var markerByStoreId = {};
    var singleInfoWindow = null;
    var markerCluster = null;

    var geocoder = null;
    var autocomplete = null;

    var currentCenter = null; // Mittelpunkt des Radius (aus Eingabe ODER Geolocation)
    var userLocation = null;  // tatsächliche User-Position (nur bei Geolocation, für spätere Nutzung z.B. Route)
    var userMarker = null;
    var typingTimer = null;
    var TYPING_DELAY = 700; // ms Pause nach letzter Eingabe

    var firstWithCoords = shops.find(function (s) {
      return s.lat !== null && s.lng !== null;
    });

    var defaultCenter = firstWithCoords
      ? { lat: firstWithCoords.lat, lng: firstWithCoords.lng }
      : { lat: 51.0, lng: 9.0 };
    var defaultZoom = firstWithCoords ? 6 : 5;

    function ensureMap() {
      if (!hasGoogleMaps()) return;
      if (map) return;

      map = new google.maps.Map(mapEl, {
        center: defaultCenter,
        zoom: defaultZoom,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        disableDefaultUI: true,
        zoomControl: true,
        styles: mapStyles
      });

      singleInfoWindow = new google.maps.InfoWindow();

      if (placeholderEl) {
        placeholderEl.style.display = "none";
      }
    }

    function ensureGeocoder() {
      if (!hasGoogleMaps()) return;
      if (!geocoder) {
        geocoder = new google.maps.Geocoder();
      }
    }

    // Optional: Google Places Autocomplete (erfordert &libraries=places im Maps-Script)
    function ensureAutocomplete() {
      if (!hasGoogleMaps()) return;
      if (!google.maps.places || autocomplete) return;

      try {
        autocomplete = new google.maps.places.Autocomplete(searchInput, {
          types: ["(regions)"]
          // ggf. einschränken:
          // componentRestrictions: { country: "de" }
        });

        autocomplete.addListener("place_changed", function () {
          var place = autocomplete.getPlace();
          if (!place || !place.geometry || !place.geometry.location) return;

          currentCenter = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          };

          // optional: schöner formatierten Namen ins Feld setzen
          if (place.formatted_address) {
            searchInput.value = place.formatted_address;
          }

          renderAll();
        });
      } catch (e) {
        console.warn("Autocomplete konnte nicht initialisiert werden:", e);
      }
    }

    // --- Route-URL (präzise Zieladresse) ----------------------------
    function getRouteUrl(store) {
      var base = "https://www.google.com/maps/dir/?api=1";

      var parts = [store.address || "", store.postalCode || "", store.city || ""]
        .map(function (p) { return String(p).trim(); })
        .filter(function (p) { return p.length > 0; });

      var destination = parts.join(" ");

      // Fallback: falls keine Adresse gepflegt ist → Koordinaten
      if (!destination && store.lat !== null && store.lng !== null) {
        destination = store.lat + "," + store.lng;
      }

      var url = base;
      if (destination) url += "&destination=" + encodeURIComponent(destination);

      // Startpunkt: preferiere echte User-Position, sonst currentCenter (getippter Ort)
      var origin =
        (userLocation && typeof userLocation.lat === "number")
          ? (userLocation.lat + "," + userLocation.lng)
          : (currentCenter && typeof currentCenter.lat === "number")
            ? (currentCenter.lat + "," + currentCenter.lng)
            : null;

      if (origin) url += "&origin=" + encodeURIComponent(origin);

      return url;
    }

    function openRouteInNewTab(store) {
      window.open(getRouteUrl(store), "_blank");
    }

    // --- Geocoding nach Texteingabe -------------------------------
    function updateCenterFromInput(callback) {
      callback = callback || function () {};
      var query = (searchInput.value || "").trim();
      if (!query) {
        // kein Text: Mittelpunkt löschen, alle Stores anzeigen
        currentCenter = null;
        callback();
        return;
      }

      ensureGeocoder();
      if (!geocoder) {
        callback();
        return;
      }

      geocoder.geocode({ address: query }, function (results, status) {
        if (status === "OK" && results[0] && results[0].geometry) {
          var loc = results[0].geometry.location;
          currentCenter = {
            lat: loc.lat(),
            lng: loc.lng()
          };
        } else {
          console.warn("Geocoding fehlgeschlagen für Eingabe:", query, status);
          // Mittelpunkt nicht verändern, wenn Geocoding fehlschlägt
        }
        callback();
      });
    }

    // --- Stores nach Radius um currentCenter filtern --------------
    function getStoresInRadius() {
      var radiusKm = parseFloat(radiusSelect.value) || 25;

      if (!currentCenter) {
        // Kein Mittelpunkt: alle Stores (z.B. initialer Zustand)
        return shops.filter(function (s) {
          return s.lat !== null && s.lng !== null;
        });
      }

      return shops.filter(function (store) {
        if (store.lat === null || store.lng === null) return false;
        var dist = getDistanceKm(
          currentCenter.lat,
          currentCenter.lng,
          store.lat,
          store.lng
        );
        return dist <= radiusKm;
      });
    }

    // --- Liste rendern --------------------------------------------
    function renderStoreList(storeList) {
      listEl.innerHTML = "";

      if (!storeList.length) {
        listEl.innerHTML = "<p>Keine Stores im gewählten Umkreis gefunden.</p>";
        return;
      }

      storeList.forEach(function (store) {
        var card = document.createElement("div");
        card.className = "store-card";
        card.dataset.id = store.id;

      var html =
        '<div class="store-name">' +
        (store.name || "") +
        "</div>" +
        '<div class="store-distance">in ' +
        (store.city || "") +
        (store.postalCode ? " (" + store.postalCode + ")" : "") +
        "</div>" +
        '<div class="store-address">' +
        (store.address || "") +
        "<br/>" +
        '<div class="store-address-row">' +
        '<span>' + (store.phone ? "Tel.: " + store.phone : "") + "</span>" +
        '<button type="button" class="route-link">' +
          '<span class="sl-location-icon" aria-hidden="true">📍</span>' +
          '<span>Routenplaner</span>' +
        '</button>'
        +
        "</div>" +
        "</div>";

        card.innerHTML = html;

        var routeBtn = card.querySelector(".route-link");
        if (routeBtn) {
          routeBtn.addEventListener("click", function (e) {
            e.stopPropagation(); // verhindert Card-Klick (Marker-Fokus)
            openRouteInNewTab(store);
          });
        }


        card.addEventListener("click", function () {
          var marker = markerByStoreId[store.id];
          if (marker && map && hasGoogleMaps()) {
            map.panTo(marker.getPosition());
            map.setZoom(12);
            google.maps.event.trigger(marker, "click");
          }
        });

        listEl.appendChild(card);
      });
    }

    // --- Marker rendern -------------------------------------------
    function renderMarkers(storeList) {
      if (!hasGoogleMaps()) return;
      ensureMap();
      if (!map) return;

      // Alte Marker entfernen
      markers.forEach(function (marker) {
        if (marker.setMap) marker.setMap(null);
      });
      markers = [];
      markerByStoreId = {};

      if (markerCluster && markerCluster.clearMarkers) {
        markerCluster.clearMarkers();
        markerCluster = null;
      }

      // alten User-Marker entfernen
      if (userMarker && userMarker.setMap) {
        userMarker.setMap(null);
        userMarker = null;
      }

      // User-Standort-Marker setzen (nur, wenn wir wirkliche Geolocation kennen)
      if (userLocation && map) {
        userMarker = new google.maps.Marker({
          position: userLocation,
          map: map,
          title: "Mein Standort",
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 6,
            fillColor: "#00754a",
            fillOpacity: 1,
            strokeColor: "#ffffff",
            strokeWeight: 2
          }
        });
      }

      var storesWithCoords = storeList.filter(function (store) {
        return store.lat !== null && store.lng !== null;
      });

      // Wenn gar keine Stores (innerhalb Radius)
      if (!storesWithCoords.length) {
        if (currentCenter) {
          map.setCenter(currentCenter);
          map.setZoom(10);
        } else if (userLocation) {
          map.setCenter(userLocation);
          map.setZoom(10);
        } else {
          map.setCenter(defaultCenter);
          map.setZoom(defaultZoom);
        }
        return;
      }

      var bounds = new google.maps.LatLngBounds();

      storesWithCoords.forEach(function (store) {
        var position = { lat: store.lat, lng: store.lng };

        var marker = new google.maps.Marker({
          position: position,
          map: map,
          title: store.name || "",
          icon: getRoeschMarkerIcon()
        });

        marker.addListener("click", function () {
          if (!singleInfoWindow) {
            singleInfoWindow = new google.maps.InfoWindow();
          }

          var routeUrl = getRouteUrl(store);

          var html =
            '<div style="font-size:13px">' +
            "<strong>" + (store.name || "") + "</strong><br/>" +
            (store.address || "") + "<br/>" +
            (store.postalCode || "") + " " + (store.city || "") + "<br/>" +
            (store.phone ? "Tel.: " + store.phone + "<br/>" : "") +
            '<a href="' + routeUrl + '" target="_blank" ' +
            'style="display:inline-flex;align-items:center;gap:4px;margin-top:4px;font-size:12px;color:#00754a;text-decoration:none;">' +
            '<span aria-hidden="true" style="font-size:16px;line-height:1">📍</span>' +
            '<span>Routenplaner</span></a>'
            +
            "</div>";

          singleInfoWindow.setContent(html);
          singleInfoWindow.open(map, marker);
        });

        markers.push(marker);
        markerByStoreId[store.id] = marker;
        bounds.extend(position);
      });

      // currentCenter mit in die Bounds nehmen (optional)
      if (currentCenter) {
        bounds.extend(currentCenter);
      }
      if (userLocation && !currentCenter) {
        bounds.extend(userLocation);
      }

      // Marker zu Clustern zusammenfassen (falls Library geladen)
      if (window.markerClusterer && window.markerClusterer.MarkerClusterer) {
        try {
          markerCluster = new window.markerClusterer.MarkerClusterer({
            map: map,
            markers: markers
          });
        } catch (err) {
          console.error("MarkerClusterer Fehler:", err);
          markerCluster = null;
        }
      }

      if (storesWithCoords.length === 1 && !currentCenter && !userLocation) {
        map.setCenter(bounds.getCenter());
        map.setZoom(12);
      } else {
        map.fitBounds(bounds);
      }
    }

    // --- Haupt-Renderfunktion ------------------------------------
    function renderAll() {
      var storesInRadius = getStoresInRadius();
      renderStoreList(storesInRadius);
      renderMarkers(storesInRadius);
    }

    // --- Events ---------------------------------------------------

    // Enter im Feld → Adresse geocoden & nach Radius filtern
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      updateCenterFromInput(renderAll);
    });

    // Beim Tippen: nach kurzer Pause automatisch geocoden + Umkreis neu berechnen
    searchInput.addEventListener("input", function () {
      if (typingTimer) {
        clearTimeout(typingTimer);
      }
      typingTimer = setTimeout(function () {
        updateCenterFromInput(renderAll);
      }, TYPING_DELAY);
    });

    // Radius ändern → neu nach Radius um aktuellen Mittelpunkt filtern
    radiusSelect.addEventListener("change", function () {
      // Wenn bisher noch kein Mittelpunkt (weder Geolocation noch Geocode),
      // wird einfach nur die Liste erneut gerendert (alle Stores).
      if (currentCenter) {
        renderAll();
      } else {
        // kein Center: zeigt trotzdem alle mit neuen Radius-Einstellungen
        renderAll();
      }
    });

    // Standort-Button → Geolocation als Mittelpunkt verwenden
    locateButton.addEventListener("click", function () {
      if (!navigator.geolocation) {
        alert("Dein Browser unterstützt keine Standortbestimmung.");
        return;
      }

      navigator.geolocation.getCurrentPosition(
        function (position) {
          userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          currentCenter = {
            lat: userLocation.lat,
            lng: userLocation.lng
          };

          // Reverse-Geocoding, um PLZ / Stadt ins Feld zu schreiben
          if (hasGoogleMaps() && google.maps.Geocoder) {
            ensureGeocoder();
            geocoder.geocode(
              { location: userLocation },
              function (results, status) {
                if (status === "OK" && results[0]) {
                  var components = results[0].address_components || [];
                  var city = "";
                  var postalCode = "";

                  components.forEach(function (comp) {
                    if (comp.types.indexOf("locality") !== -1) {
                      city = comp.long_name;
                    }
                    if (comp.types.indexOf("postal_code") !== -1) {
                      postalCode = comp.long_name;
                    }
                  });

                  var text = [postalCode, city].filter(Boolean).join(" ");
                  searchInput.value = text || "Mein Standort";
                } else {
                  searchInput.value = "Mein Standort";
                }

                renderAll();
              }
            );
          } else {
            searchInput.value = "Mein Standort";
            renderAll();
          }
        },
        function (error) {
          console.error("Geolocation-Fehler:", error);
          alert("Standort konnte nicht ermittelt werden.");
        }
      );
    });

    // Initial: alle Stores anzeigen, sobald Karte verfügbar
    (async function bootstrap() {
      if ((!shops || !shops.length) && data.dataSource) {
        const loaded = await fetchAllMetaobjectStores(data.dataSource);
        shops = normalizeShops(loaded);
      }
      renderAll();
    })();

    // Wenn Google Maps später lädt, Karte + Autocomplete initialisieren
    var pollId = setInterval(function () {
      if (hasGoogleMaps()) {
        clearInterval(pollId);
        ensureMap();
        ensureAutocomplete();
        renderAll();
      }
    }, 300);

    // Section-Handle speichern
    window.RoeschStoreLocator.sections[sectionId] = {
      getShops: function () {
        return shops;
      }
    };
  }

  // nach außen exportieren
  window.RoeschStoreLocator.initSection = initSection;
})();
